import { cycleRecommendationClientSrc17Evid864 } from '@wix/bi-logger-premium-data/v2';
import { BiUtils, CycleUtils } from '@wix/package-picker-shared';
import React from 'react';
import { useCurrentModule } from '../../components';
import { useCycleDefaultDecision } from '../useCycleDefaultDecision';
import { useBiLogger } from './useBiLogger';
import { useCommonBiEventsFields } from './useCommonBiEventsFields';
export const useInitCycleDefaultBiEvents = () => {
  const [didInit, setDidInit] = React.useState(false);
  const module = useCurrentModule();
  const {
    setBiEvent
  } = module.SDK;
  const {
    biLogger
  } = useBiLogger();
  const {
    commonBiEventsFields,
    isLoading
  } = useCommonBiEventsFields();
  React.useEffect(() => {
    if (isLoading) {
      return;
    }
    setBiEvent('onCycleDefaultServed', params => {
      biLogger == null || biLogger.report(cycleRecommendationClientSrc17Evid864({
        ...commonBiEventsFields,
        ...params
      }));
    });
    setDidInit(true);
  }, [setBiEvent, biLogger, isLoading, commonBiEventsFields]);
  const {
    servedCycle,
    productFamily,
    recommendedCycle,
    availableCycles,
    applied,
    fallbackReasons,
    ineligibleReasons,
    correlationId,
    isEligible,
    isShadow,
    isShadowPending,
    model,
    upgradeState,
    isLoading: isDecisionLoading
  } = useCycleDefaultDecision();
  const didReportServed = React.useRef(false);
  const servedCycleName = CycleUtils.convertCycleToCycleId(servedCycle);
  const recommendedPurchaseCycle = recommendedCycle ? CycleUtils.convertCycleIdToCycle(recommendedCycle) : undefined;
  React.useEffect(() => {
    if (!didInit || isDecisionLoading || isShadowPending || !servedCycleName || didReportServed.current) {
      return;
    }
    didReportServed.current = true;
    module.internals.bi.onCycleDefaultServed == null || module.internals.bi.onCycleDefaultServed({
      correlationId,
      productFamily,
      servedCycleName,
      servedCycleId: BiUtils.getBiCycle(servedCycle),
      recommendedCycle,
      recommendedCycleId: BiUtils.getBiCycle(recommendedPurchaseCycle),
      applied,
      isEligible,
      isShadow,
      recommendationModel: model === 'upgrade' ? 'second_upgrade' : undefined,
      recommendationState: upgradeState,
      fallbackReason: fallbackReasons.join(',') || undefined,
      ineligibilityReason: ineligibleReasons.join(',') || undefined,
      availableCycles: availableCycles.map(cycle => CycleUtils.convertCycleToCycleId(cycle)).join(',')
    });
  }, [didInit, isDecisionLoading, servedCycleName, module, correlationId, productFamily, recommendedCycle, applied, fallbackReasons, ineligibleReasons, isEligible, isShadow, isShadowPending, model, upgradeState, availableCycles, servedCycle, recommendedPurchaseCycle]);
  return {
    didInit
  };
};
//# sourceMappingURL=useInitCycleDefaultBiEvents.js.map